import { Fragment, useState } from "react";
import { partners } from "@/helpers/constant/content_data"
import style from "./partner_deals.module.css";


export default function PartnerDeals() {
  const [partnerList] = useState([partners[0]])
  return (
    <Fragment>
      <div className={style.partner_deals}>
        {partnerList && partnerList.map((partner) => (
          <div
            key={partner.id}
            className={style.partner_card}
          >
            <div className={style.partner_image_wrapper}>
              <a href={partner.target} target={"_blank"} rel="noreferrer">
                <img alt={partner.title} src={partner.image} />
              </a>
            </div>
          </div>
        ))}
      </div>
    </Fragment>
  );
}
